import { createAsyncThunk } from "@reduxjs/toolkit";
import { Course } from "../../models/course";
import { SectionRequest } from "../../models/section";
import { Courses } from "../../services/courses/sections";
import { ErrorResponse } from "../../services/fetch-util";
export const Sections = createAsyncThunk<(ErrorResponse & SectionRequest[]) | undefined, void, any>(
  "courses/section",
  async () => (await Courses.sections()).parsedBody
);
export const SectionCourses = createAsyncThunk<(ErrorResponse & Course[]) | undefined, any, any>(
  "section/courses",
  async ({ fetchUrl, index }) => (await Courses.recomendations(fetchUrl)).parsedBody
);
